import Image from 'next/image'
import Link from 'next/link'
import styles from './ua.module.scss'

export default function TileHeroImage(props) {

  const sizes = "(max-width: 768px) 100vw, 320px"

  const placeholderProps = props.placeholder ? {
    placeholder: props.placeholder
  } : {}

  if (props.children) return <div  className={styles.photo}>
    { props.children }
  </div>

  if (props.link) {
    return <Link href={props.link} className={styles.photo + (props.flipH ? ' ' + styles['photo-flipped-h'] : '')} prefetch={false}>
      <Image src={props.image} alt={props.alt} fill={'object-fit'} style={{ maxWidth: "100%", objectFit: props?.objectFit || "cover" }} priority={props.priority || false} sizes={sizes} placeholder={props.placeholder ? 'blur' : 'none'} blurDataURL={props.placeholder}></Image>
    </Link>
  } else {
    return <div className={styles.photo}>
      <Image {...placeholderProps} src={props.image} alt={props.alt} fill={'object-fit'} style={{ maxWidth: "100%", objectFit: props?.objectFit || "cover" }} priority={props.priority || false} sizes={sizes} placeholder={props.placeholder ? 'blur' : 'none'} blurDataURL={props.placeholder}></Image>
    </div>
  }
  
}